import { GET_RATING_DASHBOARD, GET_RATING_DASHBOARD_SUCCESS, GET_RATING_DASHBOARD_FAIL } from "./actionType";

export const getRatingDashboard = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_RATING_DASHBOARD,
  payload: { data, onSuccess, onError },
});

export const getRatingDashboardSuccess = (data = {}) => ({
  type: GET_RATING_DASHBOARD_SUCCESS,
  payload: data,
});

export const getRatingDashboardFail = (data = {}) => ({
  type: GET_RATING_DASHBOARD_FAIL,
  payload: data,
});
